import { Section, inputCls, labelCls } from "./shared";

const TEXT_FIELDS = [
  ["hero_eyebrow", "Hero — small script line", false],
  ["hero_tagline", "Hero — gold script tagline", false],
  ["about_heading", "About — heading", false],
  ["about_tagline", "About — quoted tagline", false],
  ["about_paragraph", "About — paragraph", true],
  ["about_location", "About — location line", false],
  ["testimonials_heading", "Reviews — heading", false],
  ["footer_heading", "Footer — heading", false],
  ["footer_note", "Footer — thank-you note", false],
  ["footer_legal", "Footer — legal / ABN line (tiny text at the very bottom)", false],
];

export function SocialsSection({ socials, update, saving, onSave }) {
  return (
    <Section title="Social Links" hint="Shown in the header and footer icons." section="socials" saving={saving} onSave={onSave}>
      <div className="space-y-3">
        {[["facebook", "Facebook"], ["instagram", "Instagram"], ["tiktok", "TikTok"]].map(([key, label]) => (
          <div key={key} className="flex items-center gap-3">
            <span className="w-24 shrink-0 text-sm font-medium text-wine">{label}</span>
            <input
              value={socials[key]}
              onChange={(e) => update((c) => (c.socials[key] = e.target.value))}
              data-testid={`content-social-${key}`}
              className={inputCls}
            />
          </div>
        ))}
      </div>
    </Section>
  );
}

export function TextSection({ text, update, saving, onSave }) {
  return (
    <Section title="Page Text" hint="Headings and words shown across the website." section="text" saving={saving} onSave={onSave}>
      <div className="space-y-3">
        {TEXT_FIELDS.map(([key, label, multiline]) => {
          const props = {
            value: text[key] ?? "",
            onChange: (e) => update((c) => (c.text[key] = e.target.value)),
            "data-testid": `content-text-${key}`,
            className: `${inputCls} w-full`,
          };
          return (
            <div key={key}>
              <label className={labelCls}>{label}</label>
              {multiline ? <textarea rows={4} {...props} /> : <input {...props} />}
            </div>
          );
        })}
      </div>
    </Section>
  );
}
